import { useNavigate } from "react-router-dom";
import { Login, LoginLayout } from "ui-classic-common-library";

import pkg from "../../package.json";

interface LoginPageProps {
  isLoadingSession: boolean;
}

const LoginPage = ({ isLoadingSession }: LoginPageProps) => {
  const navigate = useNavigate();
  return (
    <LoginLayout footerVersion={pkg.version} includeHeader={true}>
      <Login
        onLoginSuccess={() => navigate("/")}
        isLoadingSession={isLoadingSession}
      />
    </LoginLayout>
  );
};

export default LoginPage;
